import { render, staticRenderFns } from "./CompanyLink.vue?vue&type=template&id=c705c75c&"
import script from "./CompanyLink.vue?vue&type=script&lang=js&"
export * from "./CompanyLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports